import React, { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { useAuth } from '../context/AuthContext';

const labelSt = { fontSize: 12, color: '#888', fontWeight: 600, display: 'block', marginBottom: 4 };
const inputSt = { width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e0e0e0', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

export default function PromoPage() {
  const { getAdminToken } = useAuth();
  const [promos, setPromos]               = useState([]);
  const [promosLoading, setPromosLoading] = useState(false);
  const [promoEmail, setPromoEmail]       = useState('');
  const [promoDiscount, setPromoDiscount] = useState('');
  const [promoNote, setPromoNote]         = useState('');
  const [promoCreating, setPromoCreating] = useState(false);
  const [message, setMessage]             = useState('');

  useEffect(() => { loadPromos(); }, []);

  const showMsg = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(''), 4000);
  };

  const loadPromos = async () => {
    setPromosLoading(true);
    const { data } = await supabase.rpc('admin_list_promo_codes', { p_admin_token: getAdminToken() });
    setPromos(data?.success ? data.rows : []);
    setPromosLoading(false);
  };

  const generateCode = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    return Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  };

  const handleCreatePromo = async () => {
    if (!promoEmail.trim() || !promoEmail.includes('@')) {
      showMsg('❌ Düzgün email daxil edin');
      return;
    }
    setPromoCreating(true);
    try {
      const code = generateCode();
      const { data, error } = await supabase.rpc('admin_create_promo_code', {
        p_admin_token: getAdminToken(), p_code: code, p_email: promoEmail.trim().toLowerCase(),
        p_discount: promoDiscount ? parseInt(promoDiscount) : null, p_note: promoNote.trim() || null,
      });
      if (error) throw error;
      if (!data?.success) throw new Error(data?.error);
      showMsg(`✅ Promo kod yaradıldı: ${code} → ${promoEmail.trim()}`);
      setPromoEmail('');
      setPromoDiscount('');
      setPromoNote('');
      loadPromos();
    } catch (err) {
      showMsg('❌ Xəta: ' + err.message);
    } finally {
      setPromoCreating(false);
    }
  };

  const handleDeletePromo = async (id) => {
    if (!window.confirm('Bu promo kodu silmək istəyirsiniz?')) return;
    await supabase.rpc('admin_delete_promo_code', { p_admin_token: getAdminToken(), p_id: id });
    loadPromos();
  };

  return (
    <div style={{ padding: 24, fontFamily: 'sans-serif', maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1a1a2e', marginBottom: 4 }}>🎟️ Promo Kodlar</h1>
      <p style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>
        Email-bağlı promo kodlar yaradın. Kod yalnız həmin email ilə qeydiyyat zamanı işləyir.
      </p>

      {message && (
        <div style={{
          padding: '12px 16px', borderRadius: 10, marginBottom: 16, fontWeight: 600,
          background: message.includes('✅') ? '#E8F8F5' : '#FDEDEC',
          color: message.includes('✅') ? '#27ae60' : '#e74c3c',
        }}>{message}</div>
      )}

      {/* Yeni kod yarat */}
      <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: 16 }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>Yeni Promo Kod Yarat</h3>
        <p style={{ margin: '0 0 16px', fontSize: 12, color: '#888' }}>
          Kod avtomatik generasiya edilir. Kod yalnız daxil edilmiş email ilə qeydiyyat zamanı işləyəcək.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px 1fr', gap: 10, marginBottom: 12 }}>
          <div>
            <label style={labelSt}>Email ünvanı *</label>
            <input
              value={promoEmail}
              onChange={e => setPromoEmail(e.target.value)}
              placeholder="info@kafe.az"
              style={inputSt}
            />
          </div>
          <div>
            <label style={labelSt}>Endirim (%)</label>
            <input
              value={promoDiscount}
              onChange={e => setPromoDiscount(e.target.value.replace(/\D/g, ''))}
              placeholder="məs: 20"
              maxLength={3}
              style={inputSt}
            />
          </div>
          <div>
            <label style={labelSt}>Qeyd (ixtiyari)</label>
            <input
              value={promoNote}
              onChange={e => setPromoNote(e.target.value)}
              placeholder="məs: İlk ay pulsuz"
              style={inputSt}
            />
          </div>
        </div>

        <button
          onClick={handleCreatePromo}
          disabled={promoCreating}
          style={{
            padding: '11px 24px', borderRadius: 10, border: 'none',
            background: promoCreating ? '#bbb' : '#FF6B35',
            color: '#fff', fontWeight: 700, fontSize: 14,
            cursor: promoCreating ? 'not-allowed' : 'pointer',
          }}>
          {promoCreating ? 'Yaradılır...' : '🎟️ Kod Yarat'}
        </button>
      </div>

      {/* Siyahı */}
      <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>
            Bütün Promo Kodlar
          </h3>
          <button onClick={loadPromos} style={{ padding: '6px 14px', borderRadius: 8, border: '1px solid #ddd', background: '#f9f9f9', cursor: 'pointer', fontSize: 12 }}>
            Yenilə
          </button>
        </div>

        {promosLoading ? (
          <div style={{ textAlign: 'center', padding: 24, color: '#888' }}>Yüklənir...</div>
        ) : promos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 24, color: '#bbb' }}>Promo kod yoxdur</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #f0f0f0' }}>
                {['Kod', 'Email', 'Endirim', 'Qeyd', 'Status', 'Tarix', ''].map(h => (
                  <th key={h} style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 700, color: '#888', fontSize: 11, textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {promos.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <td style={{ padding: '10px', fontWeight: 800, fontFamily: 'monospace', fontSize: 14, color: '#FF6B35', letterSpacing: 1 }}>{p.code}</td>
                  <td style={{ padding: '10px', color: '#1a1a2e' }}>{p.email}</td>
                  <td style={{ padding: '10px', color: '#f97316', fontWeight: 700 }}>
                    {p.discount_percentage ? `-${p.discount_percentage}%` : '—'}
                  </td>
                  <td style={{ padding: '10px', color: '#666' }}>{p.note || '—'}</td>
                  <td style={{ padding: '10px' }}>
                    <span style={{
                      padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                      background: p.is_used ? '#FEF3C7' : '#E8F8F5',
                      color: p.is_used ? '#D97706' : '#27ae60',
                    }}>
                      {p.is_used ? 'İşlənib' : 'Aktiv'}
                    </span>
                  </td>
                  <td style={{ padding: '10px', color: '#888', fontSize: 12 }}>
                    {new Date(p.created_at).toLocaleDateString('az-AZ')}
                  </td>
                  <td style={{ padding: '10px' }}>
                    {!p.is_used && (
                      <button onClick={() => handleDeletePromo(p.id)}
                        style={{ padding: '4px 10px', borderRadius: 6, border: 'none', background: '#FDEDEC', color: '#e74c3c', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                        Sil
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
